module.exports = __webpack_public_path__ + "img/ribble.b6f13c2.png";